import {bool, func, object} from 'prop-types';
import React from 'react';

import {useDispatch} from 'react-redux';
import {notify} from '@actions/notifications';
import {deselectFeatureRef} from '@actions/selected-features';
import {setCollectionVisibility} from '@app/actions/collections';
import {trackEvent} from '@app/analytics';
import {useDeleteCollection} from '@app/api/collections';
import useCollectionParams from '@app/hooks/useCollectionParams';
import DeleteModal from '@components/common/DeleteModal';

const EVENT_NAME = 'Delete Collection Modal';

const DeleteCollectionModal = ({open, onClose, collection}) => {
  const dispatch = useDispatch();
  const {collectionId: activeCollectionId, resetCollection} =
    useCollectionParams();

  const {mutate: deleteCollection, isPending: isDeletingCollection} =
    useDeleteCollection({
      onSuccess: () => {
        trackEvent(EVENT_NAME, {
          action: 'Deleted collection',
        });
        onClose();
        if (activeCollectionId) {
          resetCollection();
          dispatch(deselectFeatureRef());
        }
        dispatch(setCollectionVisibility({collection, visible: false}));
      },
      onError: () => {
        dispatch(
          notify({
            severity: 'error',
            message: 'There was an error while deleting collection',
          })
        );
      },
    });

  const onDelete = () => {
    deleteCollection({collectionId: collection.id});
  };

  const handleOnClose = () => {
    trackEvent(EVENT_NAME, {
      action: 'closed modal',
    });

    onClose();
  };

  return (
    <DeleteModal
      open={open}
      onClose={handleOnClose}
      title="Delete Collection?"
      description="Are you sure you want to delete this collection? Doing so will delete all existing AOIs within the collection."
      isPending={isDeletingCollection}
      onDelete={onDelete}
    />
  );
};

DeleteCollectionModal.propTypes = {
  collection: object,
  onClose: func,
  open: bool,
};

export default DeleteCollectionModal;
